export enum DeliveryDatesMutationTypes {
  SET_AVAILABLE_DAYS = 'SET_AVAILABLE_DAYS',
  SET_FILTERED_AVAILABLE_DAYS = 'SET_FILTERED_AVAILABLE_DAYS',
  SET_UNAVAILABLE_DATES = 'SET_UNAVAILABLE_DATES',
  SET_SCHEDULE_DATES = 'SET_SCHEDULE_DATES',
  SET_AVAILABLE_EXCEPTIONS = 'SET_AVAILABLE_EXCEPTIONS',
  SET_NOTIFICATION_EXCEPTIONS = 'SET_NOTIFICATION_EXCEPTIONS',
  SET_POSM_INVENTORY_DATES = 'SET_POSM_INVENTORY_DATES',
  SET_EXCEPTION_FALLBACK = 'SET_EXCEPTION_FALLBACK',
  SET_DATE_API_FALLBACK = 'SET_DATE_API_FALLBACK',
  SET_DATES_REQUESTS_PAYLOAD = 'SET_DATES_REQUESTS_PAYLOAD',
  SET_EXEPTION_REQUESTS_PAYLOAD = 'SET_EXEPTION_REQUESTS_PAYLOAD',
  SET_SEEN_POPUP = 'SET_SEEN_POPUP'
}
